(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oralie-alpha-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oralie-alpha-motion')) {
    customElements.define('oralie-alpha-motion', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.inView = false;
        this.userPaused = false;
        this.failed = false;
        const update = () => this.updatePlayback();
        this.video.addEventListener('playing', () => {
          if (this.motion.matches) return;
          this.classList.add('is-ready');
          this.button.hidden = false;
        }, options);
        this.video.addEventListener('error', () => {
          this.failed = true;
          this.classList.remove('is-ready');
          this.button.hidden = true;
        }, options);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          update();
        }, options);
        this.motion.addEventListener('change', update, options);
        document.addEventListener('visibilitychange', update, options);
        this.observer = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          update();
        }, { threshold: 0.15 });
        this.observer.observe(this.closest('[data-osh-seed-story]') || this);
      }

      updatePlayback() {
        const shouldPlay = this.inView && !document.hidden && !this.motion.matches && !this.userPaused && !this.failed;
        this.classList.toggle('is-paused', this.userPaused);
        this.button.setAttribute('aria-label', this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        if (this.motion.matches) {
          this.classList.remove('is-ready');
          this.button.hidden = true;
        }
        if (!shouldPlay) {
          this.video.pause();
          return;
        }
        if (!this.video.getAttribute('src')) {
          const apple = /iP(ad|hone|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) || /Apple/.test(navigator.vendor);
          this.video.muted = true;
          this.video.src = apple ? this.dataset.safari : this.dataset.webm;
        }
        this.video.play().catch(() => {
          if (!this.inView || document.hidden || this.motion.matches || this.failed) return;
          this.userPaused = true;
          this.classList.add('is-paused');
          this.button.setAttribute('aria-label', this.button.dataset.playLabel);
          this.button.hidden = false;
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oralie-announcement-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oralie-announcement-marquee')) {
    customElements.define('oralie-announcement-marquee', class extends HTMLElement {
      constructor() {
        super();
        this.update = this.update.bind(this);
        this.mobile = window.matchMedia('(max-width: 749px)');
      }

      connectedCallback() {
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.parentElement);
        this.mobile.addEventListener('change', this.update);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver.disconnect();
        this.mobile.removeEventListener('change', this.update);
      }

      update() {
        const distance = Math.max(0, this.scrollWidth - this.parentElement.clientWidth);
        if (!this.mobile.matches || distance <= 1) {
          this.removeAttribute('data-overflow');
          return;
        }

        const direction = getComputedStyle(this).direction === 'rtl' ? 1 : -1;
        this.style.setProperty('--story-announcement-shift', `${direction * distance}px`);
        this.style.setProperty('--story-announcement-duration', `${Math.max(6, distance / 24 + 2)}s`);
        this.setAttribute('data-overflow', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oralie-home-trust-marquee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oralie-trust-marquee')) {
    customElements.define('oralie-trust-marquee', class extends HTMLElement {
      connectedCallback() {
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.events = new AbortController();
        this.inView = false;
        const update = () => {
          this.classList.toggle('is-ready', !this.motion.matches);
          this.classList.toggle('is-running', !this.motion.matches && this.inView && !document.hidden);
        };
        this.motion.addEventListener('change', update, { signal: this.events.signal });
        document.addEventListener('visibilitychange', update, { signal: this.events.signal });
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          update();
        });
        this.observer.observe(this);
        update();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
